/**
 * 'Orders.store' Store
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

import BaseStore from '@/utils/base-store'

export const options = {}
export default new BaseStore('orders', options)



// WEBPACK FOOTER //
// ./src/store/modules/orders.store.js